import { useNavigate } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuthStore } from '@/lib/auth/store';
import { useCreateSmsWebhook } from '../api';
import { SmsWebhookForm, type SmsWebhookFormValues } from './SmsWebhookForm';

const initial: SmsWebhookFormValues = {
  webhookName: '',
  smsText: '',
  payload: '',
  apiBuilder: {
    url: '',
    method: 'GET',
    headers: [{ key: '', value: '' }],
    body: [{ key: '', value: '' }],
    rawHeaders: '',
    rawBody: '',
    headerMode: 'key-value',
    bodyMode: 'key-value',
  },
};

export function AddSmsWebhookPage() {
  const navigate = useNavigate();
  const userId = useAuthStore((s) => s.userId);
  const isSubOrSuper = useAuthStore((s) => s.isSubOrSuperAdmin());
  const create = useCreateSmsWebhook();

  // Super-admin / sub-super-admin are not allowed to add webhooks.
  if (isSubOrSuper) return <Navigate to="/sms-webhook-list" replace />;

  return (
    <SmsWebhookForm
      mode="create"
      initialValues={initial}
      isPending={create.isPending}
      onSubmit={(payload) => {
        create.mutate(
          {
            ...payload,
            userId: Number(userId),
          },
          {
            onSuccess: (res) => {
              if (res?.message === 'Parameters Incorrect') {
                toast.error(res.message);
                return;
              }
              toast.success(res?.message ?? 'SMS webhook created');
              navigate('/sms-webhook-list');
            },
            onError: () => toast.error('Could not create the SMS webhook.'),
          },
        );
      }}
    />
  );
}
